export default __webpack_public_path__ + "static/media/farmacia-facil.7f80926e.png";